const AVATAR_STORAGE_KEY = "akanthasAvatarSeed";

/** DiceBear Glass — modern 3D, more serious than cartoon styles. */
export const AVATAR_PRESETS = [
  { id: "alex", seed: "Alex", label: "Alex" },
  { id: "morgan", seed: "Morgan", label: "Morgan" },
  { id: "jordan", seed: "Jordan", label: "Jordan" },
  { id: "casey", seed: "Casey", label: "Casey" },
  { id: "riley", seed: "Riley", label: "Riley" },
  { id: "avery", seed: "Avery", label: "Avery" },
  { id: "quinn", seed: "Quinn", label: "Quinn" },
  { id: "taylor", seed: "Taylor", label: "Taylor" },
  { id: "sage", seed: "Sage", label: "Sage" },
  { id: "cameron", seed: "Cameron", label: "Cameron" },
  { id: "drew", seed: "Drew", label: "Drew" },
  { id: "parker", seed: "Parker", label: "Parker" },
];

const DEFAULT_AVATAR_SEED = AVATAR_PRESETS[0].seed;

export const getAvatarUrl = (seed) =>
  `https://api.dicebear.com/9.x/glass/svg?seed=${encodeURIComponent(seed || DEFAULT_AVATAR_SEED)}`;

export const readStoredAvatarSeed = () => {
  try {
    const stored = localStorage.getItem(AVATAR_STORAGE_KEY);
    if (stored && AVATAR_PRESETS.some((preset) => preset.seed === stored)) {
      return stored;
    }
  } catch {
    // ignore storage errors
  }
  return DEFAULT_AVATAR_SEED;
};

export const writeStoredAvatarSeed = (seed) => {
  try {
    localStorage.setItem(AVATAR_STORAGE_KEY, seed);
  } catch {
    // ignore storage errors
  }
};
